import { render, staticRenderFns } from "./peaSummary.vue?vue&type=template&id=48ab7fa2"
import script from "./peaSummary.vue?vue&type=script&lang=js"
export * from "./peaSummary.vue?vue&type=script&lang=js"
import style0 from "./peaSummary.vue?vue&type=style&index=0&id=48ab7fa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports